import { render } from "./MessageOut.vue?vue&type=template&id=2d17e6a3&ts=true"
import script from "./MessageOut.vue?vue&type=script&lang=ts"
export * from "./MessageOut.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\selecta\\selectashopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__